// extracted by mini-css-extract-plugin
module.exports = {"MusicPerformanceHeader":"MusicPerformanceHeader_MusicPerformanceHeader__2Yp6l"};